module.exports = __webpack_public_path__ + "media/asset/images/1_KV/ITRI_cover_SP_EN-2c89ec069319ae98b0b102607a9e8610.png";